<template id="centre-edit">
  <div class="maxw">
    <h2>Editar Centre</h2>
    <b-form @submit.prevent="onSubmit" @reset="onReset" v-if="show">
       <b-row>
        <b-col>
          <b-form-group label="Centre:" label-for="input-nombre">
            <b-form-input
                id="input-nombre"
                v-model="form.nombre"
                required
                autofocus
                placeholder="Enter name"
              ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Grupo:" label-for="input-nif">
            <b-form-select
              v-model="form.grupoIdentifier"
              :options="grups"
              value-field="identifier"
              text-field="nombre"
              ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Adreça:" label-for="textarea-direccion">
            <b-form-textarea
              id="textarea-direccion"
              v-model="form.dirección"
              placeholder="Escriure Adreça Oficines - No fiscal"
              rows="2"
              max-rows="3"
              maxlength = 200
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col>
        <b-form-group label="CP:" label-for="input-cp">
            <b-form-input
                id="input-cp"
                v-model="form.cp"
                maxlength = 5
                placeholder="Escriure CP"
              ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Població:" label-for="input-poblacio">
            <b-form-input
                id="input-poblacio"
                v-model="form.poblacion"
                maxlength = 50
                placeholder="Escriure Població"
              ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Provincia:" label-for="input-provincia">
            <b-form-input
                id="input-provincia"
                v-model="form.provincia"
                maxlength = 50
                placeholder="Escriure Provincia"
              ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
          <b-col>
         <b-form-group label="Teléfono:" label-for="input-tel">
            <b-form-input
                id="input-tel"
                v-model="form.telefono"
                maxlength = 9
              ></b-form-input>
          </b-form-group>
          </b-col>
          <b-col>
         <b-form-group label="Horario:" label-for="textarea-horario">
            <b-form-textarea
              id="textarea-horario"
              v-model="form.horario"
              placeholder="Lunes a viernes ..."
              rows="2"
              max-rows="3"
              maxlength = 50
            ></b-form-textarea>
          </b-form-group>
          </b-col>
      </b-row>
      <b-row>
        <b-col>
         <b-form-group label="Página Web:" label-for="input-url">
            <b-form-input
                id="input-url"
                type="url"
                v-model="form.url"
                maxlength = 100
              ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Actiu:" label-for="input-rep">
            <b-form-checkbox v-model="form.isActive" name="check-button" switch>
              Activar / Desactivar Centro <b>(Checked: {{ form.isActive }})</b>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6"></b-col>
        <b-col class="col text-right">
          <b-button class="mr-2" variant="outline-success" type="submit">Save</b-button>
          <b-button variant="outline-primary"><router-link :to="{ name: 'Centres'}">Cancel</router-link></b-button>
        </b-col>
      </b-row>
      <b-form-input :hidden="true" type="text" v-model="form.identifier"></b-form-input>
    </b-form>
  </div>
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'

export default {
  props: {
    grups: {
      type: Array,
      required: true
    },
    form: {
      identifier: null,
      nombre: null,
      cp: null,
      poblacion: null,
      provincia: null,
      dirección: null,
      telefono: null,
      url: null,
      horario: null,
      isActive: null,
      grupoIdentifier: null
    }
  },
  data () {
    return {
      show: true
    }
  },
  methods: {
    onSubmit (evt) {
    //   evt.preventDefault()
      //   alert(JSON.stringify(this.form))
      (async () => {
        await DataAccess.putData('/api/centros', this.form.identifier, JSON.stringify(this.form))
          .then(response => {
            this.$router.push({ name: 'Centres' })
          })
          .catch(error => {
            console.log('ERROR: ', error)
          })
      })()
    },
    onReset (evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.nombre = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    }
  }
}
</script>

<style scoped>
  .maxw {
    width: 80%;
    margin: 40px auto;
  }
</style>
